/**
 * List of token symbols that should be excluded from token lists
 * in various components (swap modals, market details, etc.)
 */
export const EXCLUDED_TOKENS = [
    'TURBOS',
    'APT',
    'SLP',
    'CELO',
    'BLUB',
    'FT_BLUEFIN_STSUI_SUI',
    'AlphaFi stSUI-SUI LP',
    'exBTC',
    'eTHIRD',
    'BTCvc',
    'egUSDC',
    'eBTC',
    'eSUI',
    'eWAL',
];
